export default __webpack_public_path__ + "static/media/blindsLivingroomDown.79d404ed.gif";